import { Component } from '@angular/core';

@Component({
  selector: 'app-list-chevrons-up-down',
  imports: [],
  templateUrl: './list-chevrons-up-down.component.html',
  styleUrl: './list-chevrons-up-down.component.css',
})
export class ListChevronsUpDownComponent {

}
